<div class="admin-layout">
  @if (hasSidebarMenu()) {
    <cm-sidebar-menu
      [items]="navItems()"
      [headerIcon]="headerIcon()"
      [headerTitle]="headerTitle()"
    />
  }

  <div class="admin-content" cdkScrollable [class.overflow-hidden]="!hasSidebarMenu()">
    <div class="admin-content__wrapper" [class.admin-content__wrapper--full-width]="fullWidth()">
      <ng-content />
    </div>
  </div>
</div>
